import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import store from "assets/js/store";
import { logoutService } from "assets/js/services/authService";
import { whoami } from "assets/js/services/accountService"
import fetchRoute from "assets/js/utils/routes"

function LoggedOut() {
	let redirect = () => {
		let logoutUrl = fetchRoute('signIn')

		if (store.getState().brand?.config?.cas_logout_url) {
			logoutUrl = store.getState().brand.config.cas_logout_url
		}

		window.location = logoutUrl
	}

	let logout = () => {
		logoutService(null, redirect, null);
	}

	whoami(null, logout, redirect)

	return <></>;
}

LoggedOut.propTypes = {
	history: PropTypes.object,
};

export default withRouter(
	connect(null, null)(LoggedOut)
);